import React, { useState } from "react";

import { useTranslation } from "react-i18next";

import { BettingOfferStatus } from "@api-types/offer/offer-history/BettingOfferStatus";
import { Button } from "@components/buttons";
import EventHistoryStatusIcon from "@features/offer/shared/event/offer-history/EventHistoryStatusIcon";
import classnames from "classnames";

export function EventStatusLegend(props: { initialState?: boolean }) {
	const [isExpanded, setIsExpanded] = useState<boolean>(
		props.initialState || false
	);
	const t = useTranslation().t;

	const expandedIndicatorClasses = classnames(
		"u-icon u-icon--xtny btn__icon",
		{
			"u-icon--caret--up": isExpanded,
			"u-icon--caret--down": !isExpanded,
		}
	);

	return (
		<div className="offer__legend">
			<div className="offer__legend__header">
				<p className="u-type--sml">
					{t("ACC_STATEMENT.BET_DETAILS.COMBINATIONS.LEGEND")}
				</p>
				<Button
					iconOnly
					iconClassName={expandedIndicatorClasses}
					className="offer__toggle__btn btn btn--square btn--square--xsml btn--ghost"
					onClick={() => setIsExpanded((n) => !n)}
				/>
			</div>
			{isExpanded && (
				<div className="offer__legend__items">
					<div className="offer__legend__item">
						<EventHistoryStatusIcon
							status={BettingOfferStatus.Win}
						/>
						<span className="u-type--xsml">
							{t("COMMON.STATUS.WON")}
						</span>
					</div>
					<div className="offer__legend__item">
						<EventHistoryStatusIcon
							status={BettingOfferStatus.Refund}
						/>
						<span className="u-type--xsml">
							{t("COMMON.STATUS.REFUND")}
						</span>
					</div>
					<div className="offer__legend__item">
						<i className="u-icon u-icon--sml u-icon--minus-circle" />
						<span className="u-type--xsml">
							{t("COMMON.STATUS.LOST")}
						</span>
					</div>
				</div>
			)}
		</div>
	);
}
